import { IServiceItem, TServiceEventLabel } from './types';
import { saleServices } from './constants';

const MAX_ITEMS_COUNT = 3;

// Функция для получения рандомного индекса
const getRandomInt = (maxInt: number): number => {
  return Math.floor(Math.random() * Math.floor(maxInt));
};

// Функция для рандомизации порядка элементов в массиве
const getShuffle = (array: IServiceItem[]): IServiceItem[] => {
  return array.sort(() => Math.random() - 0.5);
};

// функция для поиска совпадений из выбранных трех рандомных сервисов в изначальном списке
const reduceArray = (initialArray: IServiceItem[], filteredArray: IServiceItem[]): IServiceItem[] => {
  return initialArray.reduce((acc, curr) => {
    // Если у элемента есть дочерние элементы
    if (curr.children) {
      // Так же фильтруем их от совпадений с массивом трех рандомных сервисов
      const filteredChild = reduceArray(curr.children, filteredArray);

      // И записываем в результат
      return [...acc, ...filteredChild];
    }

    // Ищем совпадение в сформированном массиве трех сервисов
    const findItem = filteredArray.find(({ title }) => title === curr.title);

    // Если текущий элемент не присутствует - записываем его в результат
    if (!findItem) {
      return [...acc, curr];
    }

    return acc;
  }, []);
};

// Функция выбора трех рандомных сервисов
export const getRandomThreeItems = (): IServiceItem[] => {
  // Копируем массив (что бы сохранить неизменным начальный)
  const filteredServices: IServiceItem[] = saleServices.slice();
  const resultItems: IServiceItem[] = [];

  // Собираем три рандомных сервиса
  for (let index = 0; index < MAX_ITEMS_COUNT; index++) {
    // Выбираем рандомный индекс сервиса
    const i = getRandomInt(filteredServices.length);

    // Получаем нужный сервис
    const findItem = filteredServices[i];

    // Если есть дочерные сервисы
    if (findItem.children) {
      // Выбираем рандомных среди них
      const j = getRandomInt(findItem.children.length);

      resultItems.push(findItem.children[j]);
    } else {
      resultItems.push(filteredServices[i]);
    }

    // Удаляем сервис/группу сервисов что бы исключить повторения
    filteredServices.splice(i, 1);
  }

  return resultItems;
};

// Функция формирования массива оставшихся сервисов
export const getRandomOtherItems = (randomThreeItems: IServiceItem[]): IServiceItem[] => {
  // Копируем массив (что бы сохранить неизменным начальный)
  const filteredServices: IServiceItem[] = saleServices.slice();

  // Формируем массив оставшихся сервисов
  const resultItems: IServiceItem[] = reduceArray(filteredServices, randomThreeItems);

  // Возвращаем в рандомном порядке
  return getShuffle(resultItems);
};

// Мапер для сбора сервисов в аналитику
export const servicesMapper = (services: IServiceItem[]): TServiceEventLabel[] => {
  return services.map(({ eventLabel }) => eventLabel as TServiceEventLabel);
};
